// src/components/reports/ReportSelector.jsx
import React from 'react'
import { Select } from 'antd'

const ReportSelector = ({ reportId, setReportId, validation, reportsAvailable }) => {
  return (
    <div className="mb-3 flex-1">
      <label htmlFor="report_name">Select Report</label>
      <Select
        className="w-full customSelect"
        placeholder="Choose a report"
        options={reportsAvailable}
        showSearch
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        value={reportId}
        onChange={(value, option) => {
          setReportId(value)
          validation.setFieldValue('report_name', option.label)
        }}
        onBlur={() => validation.setFieldTouched('report_name', true)}
      />
      {validation.touched.report_name && validation.errors.report_name && (
        <div className="error-message">{validation.errors.report_name}</div>
      )}
    </div>
  )
}

export default ReportSelector
